import React from "react";
import "./Preloader.css";

const Preloader = () => {
  return (
    <div className="preloader-container">
      <div className="preloader-logo">
        <span className="logo-part">maran</span>
        <span className="logo-highlight">software solution</span>
      </div>
      <div className="loading-bar">
        <div className="bar"></div>
      </div>
      <p className="loading-text">Loading...</p>
    </div>
  );
};

export default Preloader;
